
export const templates = [
  {
    id: 't1',
    title: 'Professional Invoice Template',
    description: 'Clean, branded invoice template with automatic GST calculation, payment terms, and ABN fields. Ready for all trades.',
    category: 'Templates',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '1.2 MB',
    downloads: 4850,
    icon: 'ri-file-text-line',
    image: 'https://public.readdy.ai/ai/img_res/d904a2682ec2c9154f4ff8619b63df34.jpg',
    isFeatured: true,
    isNew: false,
    isPremium: false
  },
  {
    id: 't2',
    title: 'Job Quote Estimate Form',
    description: 'Detailed quote template with material costs, labour hours, markup calculator, and terms & conditions section.',
    category: 'Templates',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '0.9 MB',
    downloads: 3720,
    icon: 'ri-draft-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20job%20quote%20estimate%20form%20document%20template%20on%20wooden%20desk%20with%20measuring%20tape%20and%20pencil%20warm%20natural%20lighting%20clean%20modern%20business%20document%20design%20minimalist%20style&width=480&height=320&seq=lib-template-quote-02&orientation=landscape',
    isFeatured: true,
    isNew: false,
    isPremium: false
  },
  {
    id: 't3',
    title: 'Weekly Timesheet Tracker',
    description: 'Track employee hours, overtime, breaks, and job allocations. Includes automatic total calculations.',
    category: 'Templates',
    trade: 'All Trades',
    format: 'XLSX',
    fileSize: '0.4 MB',
    downloads: 2980,
    icon: 'ri-time-line',
    image: 'https://readdy.ai/api/search-image?query=clean%20timesheet%20spreadsheet%20template%20document%20on%20office%20desk%20with%20coffee%20cup%20warm%20ambient%20lighting%20professional%20business%20time%20tracking%20form%20modern%20minimalist%20design%20beige%20tones&width=480&height=320&seq=lib-template-timesheet-03&orientation=landscape',
    isFeatured: false,
    isNew: true,
    isPremium: false
  },
  {
    id: 't4',
    title: 'Client Agreement Contract',
    description: 'Legally reviewed service agreement template covering scope of work, payment terms, warranties, and dispute resolution.',
    category: 'Templates',
    trade: 'All Trades',
    format: 'DOCX',
    fileSize: '0.6 MB',
    downloads: 2150,
    icon: 'ri-file-shield-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20legal%20contract%20document%20template%20on%20dark%20leather%20desk%20with%20fountain%20pen%20and%20glasses%20warm%20golden%20lighting%20elegant%20business%20agreement%20paper%20minimalist%20sophisticated%20style&width=480&height=320&seq=lib-template-contract-04&orientation=landscape',
    isFeatured: false,
    isNew: false,
    isPremium: false
  },
  {
    id: 't5',
    title: 'HVAC Service Report',
    description: 'Comprehensive service report for heating and cooling jobs. Includes system diagnostics, parts used, and recommendations.',
    category: 'Templates',
    trade: 'HVAC',
    format: 'PDF',
    fileSize: '1.5 MB',
    downloads: 1340,
    icon: 'ri-temp-cold-line',
    image: 'https://readdy.ai/api/search-image?query=hvac%20service%20report%20document%20template%20with%20technical%20diagrams%20on%20clean%20white%20desk%20warm%20lighting%20professional%20trade%20documentation%20modern%20layout%20with%20orange%20accent%20colors&width=480&height=320&seq=lib-template-hvac-05&orientation=landscape',
    isFeatured: false,
    isNew: false,
    isPremium: true
  },
  {
    id: 't6',
    title: 'Plumbing Job Card',
    description: 'On-site job card for plumbing work. Record materials, labour, photos, and client sign-off in one document.',
    category: 'Templates',
    trade: 'Plumbing',
    format: 'PDF',
    fileSize: '0.8 MB',
    downloads: 1680,
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=plumbing%20job%20card%20document%20template%20on%20workbench%20with%20copper%20pipe%20fittings%20warm%20workshop%20lighting%20professional%20trade%20form%20clean%20modern%20design%20with%20amber%20accents&width=480&height=320&seq=lib-template-plumbing-06&orientation=landscape',
    isFeatured: false,
    isNew: true,
    isPremium: false
  },
  {
    id: 't7',
    title: 'Electrical Test Certificate',
    description: 'AS/NZS 3000 compliant electrical test and tag certificate. Includes RCD testing, insulation resistance, and earth continuity.',
    category: 'Templates',
    trade: 'Electrical',
    format: 'PDF',
    fileSize: '1.1 MB',
    downloads: 2450,
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=electrical%20test%20certificate%20document%20template%20on%20desk%20with%20multimeter%20and%20safety%20equipment%20warm%20lighting%20professional%20compliance%20form%20clean%20modern%20design%20with%20amber%20gold%20accents&width=480&height=320&seq=lib-template-electrical-07&orientation=landscape',
    isFeatured: false,
    isNew: false,
    isPremium: true
  },
  {
    id: 't8',
    title: 'Project Budget Planner',
    description: 'Full project budgeting spreadsheet with material costs, labour estimates, contingency, and profit margin tracking.',
    category: 'Templates',
    trade: 'All Trades',
    format: 'XLSX',
    fileSize: '0.5 MB',
    downloads: 3100,
    icon: 'ri-money-dollar-circle-line',
    image: 'https://readdy.ai/api/search-image?query=project%20budget%20planner%20spreadsheet%20document%20on%20modern%20desk%20with%20calculator%20and%20financial%20charts%20warm%20natural%20lighting%20professional%20business%20planning%20template%20clean%20minimalist%20design&width=480&height=320&seq=lib-template-budget-08&orientation=landscape',
    isFeatured: true,
    isNew: false,
    isPremium: false
  }
];

export const checklists = [
  {
    id: 'c1',
    title: 'New Job Site Safety Checklist',
    description: 'WHS-compliant safety inspection checklist for arriving at any new job site. Covers PPE, hazards, emergency procedures.',
    category: 'Checklists',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '0.7 MB',
    downloads: 5200,
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=workplace%20safety%20checklist%20document%20with%20checkmarks%20on%20clipboard%20at%20construction%20site%20warm%20golden%20hour%20lighting%20professional%20safety%20inspection%20form%20clean%20modern%20design%20with%20orange%20accents&width=480&height=320&seq=lib-checklist-safety-01&orientation=landscape',
    isFeatured: true,
    isNew: false,
    isPremium: false,
    items: ['PPE verification', 'Hazard identification', 'Emergency exits', 'First aid kit', 'Site induction']
  },
  {
    id: 'c2',
    title: 'End-of-Job Completion Checklist',
    description: 'Ensure nothing is missed before leaving a job. Quality checks, cleanup, client walkthrough, and sign-off steps.',
    category: 'Checklists',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '0.5 MB',
    downloads: 3890,
    icon: 'ri-checkbox-circle-line',
    image: 'https://readdy.ai/api/search-image?query=job%20completion%20checklist%20document%20with%20green%20checkmarks%20on%20clean%20desk%20warm%20lighting%20professional%20quality%20assurance%20form%20modern%20minimalist%20design%20with%20teal%20accents&width=480&height=320&seq=lib-checklist-completion-02&orientation=landscape',
    isFeatured: true,
    isNew: false,
    isPremium: false,
    items: ['Quality inspection', 'Site cleanup', 'Client walkthrough', 'Photo documentation', 'Sign-off']
  },
  {
    id: 'c3',
    title: 'Vehicle & Tool Inventory',
    description: 'Daily vehicle and tool check for tradies. Track equipment condition, missing items, and maintenance schedules.',
    category: 'Checklists',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '0.6 MB',
    downloads: 2100,
    icon: 'ri-truck-line',
    image: 'https://readdy.ai/api/search-image?query=vehicle%20tool%20inventory%20checklist%20document%20on%20work%20truck%20tailgate%20with%20organized%20tools%20warm%20morning%20lighting%20professional%20trade%20equipment%20tracking%20form%20clean%20design&width=480&height=320&seq=lib-checklist-vehicle-03&orientation=landscape',
    isFeatured: false,
    isNew: true,
    isPremium: false,
    items: ['Vehicle condition', 'Power tools', 'Hand tools', 'Safety gear', 'Consumables']
  },
  {
    id: 'c4',
    title: 'Roof Inspection Checklist',
    description: 'Detailed roof assessment covering structure, flashing, gutters, ventilation, and damage documentation.',
    category: 'Checklists',
    trade: 'Roofing',
    format: 'PDF',
    fileSize: '0.9 MB',
    downloads: 1560,
    icon: 'ri-home-line',
    image: 'https://readdy.ai/api/search-image?query=roof%20inspection%20checklist%20document%20with%20building%20diagrams%20on%20clipboard%20warm%20lighting%20professional%20roofing%20assessment%20form%20clean%20modern%20design%20with%20amber%20accents&width=480&height=320&seq=lib-checklist-roof-04&orientation=landscape',
    isFeatured: false,
    isNew: false,
    isPremium: false,
    items: ['Structural integrity', 'Flashing condition', 'Gutter assessment', 'Ventilation check', 'Damage report']
  },
  {
    id: 'c5',
    title: 'Bathroom Renovation Checklist',
    description: 'Step-by-step renovation checklist from demolition to final fit-off. Covers waterproofing, tiling, plumbing, and electrical.',
    category: 'Checklists',
    trade: 'Plumbing',
    format: 'PDF',
    fileSize: '1.0 MB',
    downloads: 2780,
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=bathroom%20renovation%20checklist%20document%20with%20floor%20plan%20diagrams%20on%20desk%20warm%20lighting%20professional%20renovation%20planning%20form%20clean%20modern%20design%20with%20teal%20accents&width=480&height=320&seq=lib-checklist-bathroom-05&orientation=landscape',
    isFeatured: false,
    isNew: false,
    isPremium: true,
    items: ['Demolition plan', 'Waterproofing', 'Plumbing rough-in', 'Tiling layout', 'Final fit-off']
  },
  {
    id: 'c6',
    title: 'Quarterly Business Health Check',
    description: 'Review your trade business performance every quarter. Covers finances, client satisfaction, marketing, and growth goals.',
    category: 'Checklists',
    trade: 'All Trades',
    format: 'PDF',
    fileSize: '0.8 MB',
    downloads: 1920,
    icon: 'ri-line-chart-line',
    image: 'https://readdy.ai/api/search-image?query=business%20health%20check%20document%20with%20charts%20and%20graphs%20on%20modern%20desk%20warm%20lighting%20professional%20quarterly%20review%20form%20clean%20minimalist%20design%20with%20amber%20gold%20accents&width=480&height=320&seq=lib-checklist-business-06&orientation=landscape',
    isFeatured: false,
    isNew: true,
    isPremium: false,
    items: ['Revenue review', 'Expense audit', 'Client feedback', 'Marketing ROI', 'Goal setting']
  }
];

export const allResources = [...templates, ...checklists];

export const libraryCategories = [
  { id: 'all', label: 'All Resources', icon: 'ri-apps-2-line', count: 14 },
  { id: 'Templates', label: 'Templates', icon: 'ri-file-copy-2-line', count: 8 },
  { id: 'Checklists', label: 'Checklists', icon: 'ri-checkbox-multiple-line', count: 6 }
];

export const tradeFilters = [
  'All Trades', 'HVAC', 'Plumbing', 'Electrical', 'Roofing'
];

export const formatFilters = [
  'All Formats', 'PDF', 'DOCX', 'XLSX'
];

export const libraryStats = [
  { label: 'Free Templates', value: '14+', icon: 'ri-file-copy-2-line' },
  { label: 'Total Downloads', value: '38K+', icon: 'ri-download-cloud-2-line' },
  { label: 'Trade Categories', value: '7', icon: 'ri-tools-line' },
  { label: 'Updated Monthly', value: '100%', icon: 'ri-refresh-line' }
];
